module.exports = __webpack_public_path__ + "static/media/homeitem11.b9cf07a5.png";